import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieTapDark.json';

const Tap = (props) => (
    <Icon iconName="TapDark" {...props}>
        <LottieAnimation animationData={animationData} />
    </Icon>
);

export default Tap;
